namespace $.$$ {
	$mol_style_define( $shm_hitalama_components_settings, {
		flexDirection: 'column', minWidth: 0, maxWidth: '100%',
		Actions: { flexWrap: 'wrap' },
	})
}
